import React, { useEffect, useState } from 'react';
import { FaTrash, FaPlus, FaSearch, FaQuoteLeft, FaBook, FaChevronLeft } from 'react-icons/fa';
import { FaPencil } from "react-icons/fa6";
import Select from 'react-select';
import { motion, AnimatePresence } from 'framer-motion';
import ApiService from '../../models/ApiService';

const Shayari = () => {
    const [shayaris, setShayaris] = useState([]);
    const [shayars, setShayars] = useState([]);
    const [formData, setFormData] = useState({
        id: 0,
        poet_id: '',
        poet: '',
        urdu: '',
        roman: '',
        devnagari: '',
        poet_hindi: '',
        poet_urdu: '',
        no: 0,
        is_active: true // Add is_active to form data
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedShayar, setSelectedShayar] = useState();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchShayari();
        fetchShayar();
    }, []);

    const fetchShayar = async () => {
        try {
            const res = await ApiService.Shayar();
            const formattedShayars = res.data.responseContent.map(shayar => ({
                value: shayar.id,
                label: shayar.name,
                name: shayar.name,
                poet_hindi: shayar.hindi,
                poet_urdu: shayar.urdu,
            }));
            setShayars(formattedShayars);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchShayari = async () => {
        try {
            setIsLoading(true);
            const res = await ApiService.Shayari()
            console.log(res);

            setShayaris(res.data.responseContent);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Add toggle status handler for shayari
    const handleToggleStatus = async (shayariId, currentStatus) => {
        try {
            const newStatus = !currentStatus;

            await ApiService.ToggleShayari(shayariId);

            setShayaris(prev =>
                prev.map(shayari =>
                    shayari.no === shayariId
                        ? { ...shayari, is_published: newStatus }
                        : shayari
                )
            );

            console.log(`Shayari ${newStatus ? 'activated' : 'deactivated'} successfully`);
        } catch (error) {
            console.error('Error updating shayari status:', error);
        }
    };


    const handleShayarChange = (selectedOption) => {
        console.log(selectedOption);
        setFormData(prev => ({
            ...prev,
            poet_id: selectedOption?.value || '',
            poet: selectedOption?.name || '',
            poet_hindi: selectedOption?.poet_hindi || '',
            poet_urdu: selectedOption?.poet_urdu || '',
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const filteredShayaris = selectedShayar
        ? shayaris.filter(shayari => shayari.poet === selectedShayar)
        : shayaris.filter(shayari =>
            (shayari.poet && shayari.poet.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (shayari.urdu && shayari.urdu.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (shayari.devnagari && shayari.devnagari.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (shayari.roman && shayari.roman.toLowerCase().includes(searchTerm.toLowerCase()))
        );

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Validate required fields
            if (!formData.poet_id) {
                alert('Please select a Shayar');
                return;
            }
            if (!formData.urdu) {
                alert('Urdu text is required');
                return;
            }
            if (!formData.devnagari && !formData.roman) {
                alert('Please provide either Devnagari or Roman text');
                return;
            }

            const payload = {
                poet_id: formData.poet_id,
                urdu: formData.urdu,
                roman: formData.roman || null,
                devnagari: formData.devnagari || null,
                no: formData.no || null,
                poet_urdu: formData.poet_urdu || null,
                poet_hindi: formData.poet_hindi || null,
                poet: formData.poet || null,
                is_active: formData.is_active !== false // Ensure boolean
            };

            let res;
            if (formData.id) {
                res = await ApiService.UpdateShayari(formData.id, {
                    ...payload,
                    no: formData.no
                });
            } else {
                res = await ApiService.AddShayari(payload);
            }

            if (res.data && res.data.success) {
                fetchShayari();
                setIsModalOpen(false);
                resetForm();
            } else {
                alert(res.data?.message || 'Update failed');
            }

        } catch (error) {
            console.error('Error:', error);
            alert(error.response?.data?.message || 'An error occurred');
        }
    };

    const resetForm = () => {
        setFormData({
            id: null,
            poet_id: '',
            poet: '',
            urdu: '',
            poet_urdu: '',
            roman: '',
            devnagari: '',
            no: null,
            is_active: true
        });
    };

    const handleEdit = (shayari) => {
        const selectedShayar = shayars.find(s => s.name === shayari.poet);
        console.log(shayari);

        setFormData({
            id: shayari.no,
            poet_id: selectedShayar?.value || '',
            poet: shayari.poet || '',
            urdu: shayari.urdu || '',
            roman: shayari.roman || '',
            poet_urdu: shayari.poet_urdu || '',
            devnagari: shayari.devnagari || '',
            no: shayari.no || null,
            is_active: shayari.is_active !== false // Set from shayari data
        });
        setIsModalOpen(true);
    };

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this Shaa'irii?");
        if (!confirmDelete) return;

        try {
            console.log(id);
            await ApiService.DeleteShayari(id);
            fetchShayari();
        } catch (error) {
            console.error('Error deleting shayari:', error);
        }
    };

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[--primary-color]"></div>
            </div>
        );
    }

    return (
        <div className="mx-auto p-4" id='primary-fonts'>
            <h1 className="text-3xl font-bold mb-8 text-[--text-color] flex items-center gap-2">
                <FaBook className="text-[--primary-color]" /> Shaa'irii Collection
            </h1>

            <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
                <div className="relative w-full md:w-96">
                    {selectedShayar ? (
                        <button
                            onClick={() => setSelectedShayar(null)}
                            className="flex items-center gap-2 text-[--text-color-g] pl-10 pr-4 py-2 w-full text-left"
                        >
                            <FaChevronLeft /> Back to all shaa'ir
                        </button>
                    ) : (
                        <>
                            <input
                                type="text"
                                placeholder="Search shaa'irii by content or poet..."
                                className="w-full pl-10 pr-4 py-2 border border-[--border-color-o] rounded-lg focus:outline-none focus:ring-1 focus:ring-[--border-color-o]"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <FaSearch className="absolute left-3 top-3 text-gray-400" />
                        </>
                    )}
                </div>
                <button
                    onClick={() => {
                        setFormData({
                            id: null,
                            poet_id: '',
                            poet_urdu: '',
                            poet: '',
                            urdu: '',
                            roman: '',
                            devnagari: '',
                            no: null,
                            is_active: true
                        });
                        setIsModalOpen(true);
                    }}
                    className="w-full md:w-auto bg-[--primary-btn-color] hover:bg-[--secondary-btn-color] text-white px-6 py-2 rounded-lg flex items-center gap-2 transition duration-200 shadow-md"
                >
                    <FaPlus /> Add Shaa'irii
                </button>
            </div>

            {!selectedShayar ? (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {[...new Set(
                        shayaris
                            .filter(shayari =>
                                shayari.poet && shayari.poet.toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .map(shayari => shayari.poet)
                    )].filter(Boolean).map((shayar) => (
                        <div
                            key={shayar}
                            onClick={() => setSelectedShayar(shayar)}
                            className="bg-white p-6 rounded-lg shadow-md border border-[--border-color-g] hover:shadow-lg transition duration-300 cursor-pointer text-center"
                        >
                            <div className="text-xl font-semibold text-[--text-color-g]">{shayar}</div>
                            <div className="text-sm text-gray-500 mt-1">
                                {shayaris.filter(s => s.poet === shayar).length} shaa'irii
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <h2 className="text-2xl font-bold mb-6 text-[--text-color] flex items-center gap-2">
                        <span className="text-[--text-color-g]">{selectedShayar}</span>
                    </h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {filteredShayaris.length > 0 ? (
                            filteredShayaris.map((shayari) => (
                                <div
                                    key={shayari.no}
                                    className={`bg-white rounded-lg shadow-md overflow-hidden border border-[--border-color-g] hover:shadow-lg transition duration-300 ${shayari.is_active === false ? 'opacity-60' : ''
                                        }`}
                                >
                                    <div className="p-4">
                                        {/* Urdu Content */}
                                        <div className="flex justify-end mb-4">
                                            <p
                                                className="text-lg text-[--text-color-g]"
                                                id='primary-urdu-fonts'
                                                dir='rtl'
                                                dangerouslySetInnerHTML={{ __html: shayari.urdu.replace(/\n/g, '<br />') }}
                                            />
                                        </div>
                                        {/* Poet Name in Urdu */}
                                        {shayari.poet_urdu && (
                                            <div className="flex justify-end mb-4">
                                                <p
                                                    className="text-sm font-semibold text-[--text-color-g]"
                                                    id='primary-urdu-fonts'
                                                    dir='rtl'
                                                    style={{ fontStyle: 'italic' }}
                                                >
                                                    — {shayari.poet_urdu}
                                                </p>
                                            </div>
                                        )}
                                        {shayari.devnagari && (
                                            <div className="mb-4 bg-gray-50 p-3 rounded">
                                                <p className="text-base text-black"
                                                    dangerouslySetInnerHTML={{ __html: shayari.devnagari.replace(/\n/g, '<br />') }}
                                                />
                                            </div>
                                        )}
                                        {/* poet name hindi */}
                                        {shayari.poet_hindi && (
                                            <div className="flex justify-start mb-4">
                                                <p
                                                    className="text-sm font-semibold text-[--text-color-g]"
                                                    style={{ fontStyle: 'italic' }}
                                                >
                                                    {shayari.poet_hindi}
                                                </p>
                                            </div>
                                        )}
                                        {shayari.roman && (
                                            <div className="mb-4 bg-gray-50 p-3 rounded">
                                                <p className="text-base text-black"
                                                    dangerouslySetInnerHTML={{ __html: shayari.roman.replace(/\n/g, '<br />') }}
                                                />
                                            </div>
                                        )}

                                        {/* Footer with English Poet Name and Actions */}
                                        <div className="flex justify-between items-center mt-4 pt-3 border-t border-[--border-color-g]">
                                            <span className="text-sm font-semibold text-[--text-color-g]">{shayari.poet}</span>

                                            <div className="flex items-center gap-2">
                                                {/* Toggle Switch */}
                                                <label className="flex items-center gap-2 cursor-pointer p-1 hover:bg-gray-50 rounded-lg transition-colors">
                                                    <input
                                                        type="checkbox"
                                                        checked={shayari.is_published}
                                                        onChange={() => handleToggleStatus(shayari.no, shayari.is_published)}
                                                        className="hidden"
                                                    />

                                                    <div className={`w-8 h-4 flex items-center rounded-full p-0.5 transition-colors 
        ${shayari.is_published ? 'bg-green-500' : 'bg-gray-400'}`}>

                                                        <div className={`bg-white w-3 h-3 rounded-full shadow-md transform transition-transform duration-200 
            ${shayari.is_published ? 'translate-x-4' : 'translate-x-0'}`} />
                                                    </div>
                                                </label>


                                                <button
                                                    onClick={() => handleEdit(shayari)}
                                                    className="p-2 text-[--primary-btn-color] hover:bg-[--primary-btn-color] hover:text-white rounded-full transition-colors"
                                                    title="Edit"
                                                >
                                                    <FaPencil />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(shayari.no)}
                                                    className="p-2 text-red-500 hover:bg-red-500 hover:text-white rounded-full transition-colors"
                                                    title="Delete"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-span-full text-center py-10">
                                <p className="text-lg text-gray-600">No shayaris found for this poet</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {isModalOpen && (
                <AnimatePresence>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
                    >
                        <motion.div
                            initial={{ scale: 0.95, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.95, opacity: 0 }}
                            transition={{ duration: 0.25 }}
                            className="bg-white rounded-lg shadow-xl w-full max-w-screen-md max-h-[90vh] overflow-y-auto"
                        >
                            <div className="p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h2 className="text-xl font-semibold text-[--text-color]">
                                        {formData.id ? 'Edit Shaa\'irii (Poetry)' : 'Add New Shaa\'irii (Poetry)'}
                                    </h2>
                                    {/* {formData.id && formData.no && (
                                        <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                            Poetry #{formData.no}
                                        </span>
                                    )} */}
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <label className="block text-[--text-color] font-bold mb-2" htmlFor="poet">
                                                Shaa'ir Name
                                            </label>
                                            <Select
                                                id="poet"
                                                name="poet"
                                                options={shayars}
                                                value={shayars.find(option => option.value === formData.poet_id)}
                                                onChange={handleShayarChange}
                                                placeholder="Select a Shaa'ir"
                                                className="w-full border border-[--border-color-o] rounded-lg focus:outline-none focus:ring-1 focus:ring-[--border-color-o]"
                                                classNamePrefix="react-select"
                                                isClearable
                                                required
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                            />
                                        </div>

                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-[--text-color] font-bold mb-2" htmlFor="urdu">
                                            Urdu
                                        </label>
                                        <textarea
                                            id="primary-urdu-fonts"
                                            name="urdu"
                                            value={formData.urdu}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-[--border-color-o] rounded-lg focus:outline-none focus:ring-1 focus:ring-[--border-color-o]"
                                            rows="3"
                                            dir='rtl'
                                            required
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-[--text-color] font-bold mb-2" htmlFor="devnagari">
                                            Devnagari
                                        </label>
                                        <textarea
                                            id="devnagari"
                                            name="devnagari"
                                            value={formData.devnagari}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-[--border-color-o] rounded-lg focus:outline-none focus:ring-1 focus:ring-[--border-color-o]"
                                            rows="3"
                                            required
                                        />
                                    </div>
                                    <div className="mb-4">
                                        <label className="block text-[--text-color] font-bold mb-2" htmlFor="roman">
                                            Roman
                                        </label>
                                        <textarea
                                            id="roman"
                                            name="roman"
                                            value={formData.roman}
                                            onChange={handleInputChange}
                                            className="w-full px-3 py-2 border border-[--border-color-o] rounded-lg focus:outline-none focus:ring-1 focus:ring-[--border-color-o]"
                                            rows="3"
                                        />
                                    </div>
                                    <div className="flex justify-end space-x-3">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setIsModalOpen(false);
                                                resetForm();
                                            }}
                                            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition duration-200"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-[--primary-btn-color] text-white rounded-lg hover:bg-[--secondary-btn-color] transition duration-200 shadow-md"
                                        >
                                            {formData.id ? 'Update' : 'Save'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </motion.div>
                    </motion.div>
                </AnimatePresence>
            )}
        </div>
    );
};

export default Shayari;